import React from "react";
import {
  createRazorPayTransaction,
  getRazorpayOrder,
  getCouponDetails,
} from "../../api/api";
import { useAuthContext } from "../../context/AuthContext";
import { toast } from "react-toastify";
import { useEffect, useState, useRef } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react";

const BillingPage = () => {
  const plan = useLocation().search;
  const auth = useAuthContext();
  const name = new URLSearchParams(plan).get("plan");
  const index = name == "249" ? 0 : 1;

  const navigate = useNavigate();

  let subscriptionModels = [
    {
      rupeePrice: "Rs. 249",
      weeks: 4,
      price: 249,
      title: "Four weeks personalised Program of Getactyv",
      details: [
        " personalised Program",
        "Full Access to wide range of Exercises, Routines, Games",
        "Personalised performance analytics",
      ],
    },
    {
      rupeePrice: "Rs. 2499",
      weeks: 48,
      price: 2499,
      title: "Six Weeks personalised Program of Getactyv",
      details: [
        "Fourty eight Weeks personalised Program",
        "Full Access to wide range of Exercises, Routines, Games",
        "Personalised performance analytics",
        "On Call, Expert Assistance - 1",
      ],
    },
  ];
  let sub = subscriptionModels[index];
  const [showLoading, setShowLoading] = useState(false);
  const [finalPrice, setFinalPrice] = useState(sub.price);
  const [codeError, setCodeError] = useState({});
  const [showAuth, setShowAuth] = useState(false);
  const [success, setSuccess] = useState(" ");
  const [message, setMessage] = useState(" ");
  const [credit, setCredit] = useState(" ");
  const [discount, setDiscount] = useState(0);
  const [code, setCode] = useState(false);
  const refInput = useRef(null);

  // Apply Coupon function
  let coupon;
  const getCoupon = async () => {
    const cup = await getCouponDetails(code);
    if (!cup.success) {
      setCodeError({
        msg: cup.message,
        isError: true,
      });
    }
    // else if (cup.success == '') {
    //   setCodeError({
    //     msg: "Invalid code !",
    //     isError: true
    //   })
    // }
    else {
      // setCodeError("Congrats, you have got " + cup.credit + "% discount");
      setCodeError({
        msg: "Congrats, you have got " + cup.credit + "% discount",
        isError: false,
      });
      const dis = Math.floor(
        parseInt(sub.price) * (parseInt(cup.credit) / 100)
      );
      setDiscount(dis);
      setFinalPrice(sub.price - dis);
      setCredit(cup.credit + "%");
    }
  };
  const loadScript = (src) => {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = src;
      script.onload = () => {
        resolve(true);
      };
      script.onerror = () => {
        resolve(false);
      };
      document.body.appendChild(script);
    });
  };

  useEffect(() => {
    loadScript("https://checkout.razorpay.com/v1/checkout.js");
  });

  // RazorPay Integration
  const displayRazorPay = async (subscriptionModels) => {
    if (!auth.state.user) {
      toast("Please login to subscribe", { type: "error" });
      return;
    } else {
      try {
        const expiresAt = new Date(parseInt(auth.state.user.expiresAt));
        const isExpired = expiresAt < new Date();
        if (!isExpired && auth.state.user.trail === 0) {
          toast("You are already subscribed");
          return;
        }
      } catch (error) {}
    }

    setShowLoading(true);

    const order = await getRazorpayOrder(finalPrice);
    if (!order) {
      toast("Something went wrong, please try again");
      setShowLoading(false);
      return;
    }
    const options = {
      key: "rzp_live_0JqfhMT6OpmMvy",
      description: "Getactyv Subscription",
      order_id: order.id,
      handler: async function (response) {
        if (response.razorpay_payment_id && response.razorpay_signature) {
          const data = {
            paymentId: response.razorpay_payment_id,
            subscriptionId: order.id,
            created_at: order.created_at,
            razorpay_signature: response.razorpay_signature,
          };
          await createRazorPayTransaction(data);
          await auth.updateUser();
          // setShowPaymentSuccessDialog(true);
          toast("Payment Successfull");
          navigate("/payment_Complete");
        } else {
          toast("Payment Failed");
        }
      },
      prefill: {
        name: "auth.state.user",
        email: "",
      },
    };

    const paymentObject = new window.Razorpay(options);
    paymentObject.on("payment.failed", function (response) {
      toast("Payment Failed: " + response.error.description, { type: "error" });
    });
    paymentObject.open();
  };

  // onClick Function
  const applyCoupon = () => {
    if (code == false) {
      alert("enter coupon");
    } else {
      getCoupon();
    }
  };

  return (
    <div className="w-full relative flex flex-col bg-[#0E0E11] p-4 md:p-8">
      <div className=" flex flex-col justify-center pb-4">
        <p className="font-poppins text-white font-bold text-3xl md:text-4xl leading-snug mt-10 md:ml-8 ml-2">
          Complete <span className="text-primary-neonGreen">Purchase</span>
        </p>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 ml-2 mr-4 md:m-8 gap-8">
        <div className="w-full grid grid-rows-3 gap-5 py-10 px-8 text-white h-[308px]  bg-[#24242D] rounded-md">
          <p className="text-white font-bold text-xl md:text-2xl">Pay Online</p>
          <p className="text-white text-base md:text-md text-opacity-75">
            By clicking below, you will be directed to our trusted payment
            gateway
          </p>
          <button
            // {...subscriptionModel}
            className="flex justify-center items-center px-4 button bg-[#3E0CA7] rounded-sm text-white text-sm md:w-2/5 md:h-2/3 "
            onClick={() => {
              if (auth.state.user) displayRazorPay(subscriptionModels);
              else {
                // setShowAuth(true);
                navigate("/login");
              }
            }}
          >
            Complete Payment
            <Icon
              icon="uil:external-link-alt"
              className="flex items-center w-5 h-5 text-primary-white mx-2"
            />
          </button>
        </div>
        <div className="flex justify-center text-white h-[448px] bg-[#24242D] rounded-md ">
          <div className="grid grid-rows-5 gap-1 md:gap-2 my-10 mx-10">
            <div className="">
              <p className="text-white font-bold text-xl md:text-2xl">
                Payment Details
              </p>
            </div>
            <div className="">
              <p className="text-white text-sm md:text-md mt-2 md:mt-4 mb-2 text-opacity-75">
                Below is the breakdown of your payment
              </p>
            </div>
            <div className="grid grid-col-2 gap-9  md:gap-48">
              <p className="col-start-1">1 x </p>
              <p className="text-right col-start-2">INR {sub.price}/-</p>
            </div>
            <div className="grid grid-col-2">
              <p className="col-start-1">Discount</p>
              <p className="text-right col-start-2">INR {discount}/-</p>
            </div>
            <hr className="w-full" />
            <div className="grid grid-col-2">
              <p className="col-start-1 font-bold">
                Order Total (inc. all taxes)
              </p>
              <p className="text-right col-start-2 font-bold">
                {finalPrice} /-
              </p>
            </div>
          </div>
        </div>
        <div className="flex"></div>
        <div className="flex justify-center text-white h-[364px]  bg-[#24242D] rounded-md ">
          <div className="grid grid-rows-2 mx-10 my-10 gap-5">
            <div className="row-start-1">
              <p className="flex justify-center text-white text-center font-bold text-xl md:text-2xl">
                Available Promo Codes
              </p>
              <div className="md:w-full w-[300px] h-[200px] bg-[rgb(16,18,24)] rounded-sm text-white jutify-center px-4 md:px-10 py-5 md:py-10 my-4 md:my-8 border-dashed border-2 border-[#525252] grid grid-row-2 gap-5">
                <div className="grid grid-col-2 md:space-x-4 space-x-2">
                  <input
                    className="bg-[#101218] text-white md:w-60 w-40"
                    placeholder="XXXXXX"
                    id="couponCode"
                    onChange={(evt) => setCode(evt.target.value)}
                  />
                  <button
                    className="flex col-start-2 items-center"
                    onClick={applyCoupon}
                  >
                    APPLY
                  </button>
                </div>
                <hr className="w-full" />
                <div>
                  <p
                    className={`${
                      codeError?.isError ? "text-red-700" : "text-[#00FF00]"
                    } text-xs md:text-md text-opacity-80`}
                  >
                    {codeError?.msg}
                    {codeError?.isError}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BillingPage;
